import { type FC } from "react";

import { useQuery } from "@apollo/client/react";

import { DashboardProjectsIntakeInterviewDocument } from "@app_schema";

import { IntakeInterviewLayout } from "@styled/intake_outline";

import { IntakePane } from "../intake_pane";
import { IntakeOutlineView } from "./intake_outline_view";
import { IntakeStatusCard } from "./intake_status_card";

// The "Intake interview" section: where the interview stands and the office's
// next step, beside the outline once the claimant has answered.
export const IntakeInterviewPane: FC<{
  projectId: string;
  // Inside the guided panel on a case with no files, which is a card already.
  flat?: boolean;
}> = ({ projectId, flat = false }) => {
  const { data } = useQuery(DashboardProjectsIntakeInterviewDocument, {
    variables: { id: projectId },
    // Edit case changes what a link needs, and the claimant moves on between
    // visits, so the tab reads fresh each time it opens.
    fetchPolicy: "cache-and-network",
  });
  const project = data?.project;
  if (!project) return null;

  const interview = project.intakeInterview;
  const status = <IntakeStatusCard project={project} flat={flat} />;
  const outline = interview && interview.answersCount > 0 && (
    <IntakeOutlineView interview={interview} />
  );

  if (flat) {
    return (
      <>
        {status}
        {outline}
      </>
    );
  }

  return (
    <IntakePane
      title="Intake interview"
      subtitle="Send the claimant a link. They answer the intake questions out loud, and you review the outline before the exam."
    >
      {outline ? (
        <IntakeInterviewLayout rail={status}>{outline}</IntakeInterviewLayout>
      ) : (
        status
      )}
    </IntakePane>
  );
};
